import {
  keepPreviousData,
  queryOptions,
  skipToken,
} from '@tanstack/react-query'

import { fetchAllPages } from '@/utils/api/fetchAllPages'

import type { ContractsFilterParams } from '../types/contracts.types'
import { contractsApi } from './contractsApi'

const CONTRACTS_PAGE_SIZE = 200

export const contractsQueries = {
  all: () => ['contracts'] as const,
  lists: () => [...contractsQueries.all(), 'list'] as const,
  list: (organisationId: string, params: ContractsFilterParams) =>
    queryOptions({
      queryKey: [...contractsQueries.lists(), organisationId, params],
      queryFn: organisationId
        ? ({ signal }) =>
            fetchAllPages((page) =>
              contractsApi.getContracts(
                organisationId,
                { ...params, page, pageSize: CONTRACTS_PAGE_SIZE },
                { signal }
              )
            )
        : skipToken,
      placeholderData: keepPreviousData,
    }),
}
